<template>
  <l-table
    ref="LTable"
    :module-name="MODULE_NAME"
    :table-columns="tableColumns"
  >
    <template #create-button>
      <b-button
        v-if="$can('manage', 'All')"
        v-b-toggle.sidebar-create-scientific-topics
        variant="primary"
        @click="create()"
      >
        {{ $t('Create') }}
      </b-button>
    </template>
    <template #create-body>
      <create @refetchData="refetchData" />
    </template>

    <template #cell(region)="{ data }">
      {{ $langName(data.value) }}
    </template>

    <!-- Column: Actions -->
    <template #cell(actions)="{ data }">
      <div class="text-nowrap">
        <feather-icon
          v-if="$can('manage', 'All')"
          v-b-toggle.sidebar-create-scientific-topics
          icon="EditIcon"
          class="cursor-pointer"
          size="16"
          @click="update(data.item)"
        />

        <feather-icon
          v-if="$can('manage', 'All')"
          :id="`invoice-row-${data.item.id}-preview-icon`"
          icon="TrashIcon"
          size="16"
          class="mx-1 cursor-pointer"
          @click="remove(data.item)"
        />
      </div>
    </template>
  </l-table>

</template>

<script>
import {
  BButton, VBToggle,
} from 'bootstrap-vue'
import { onUnmounted } from '@vue/composition-api'
import Ripple from 'vue-ripple-directive'
import store from '@/store'
import config from './config'
import scientificTopics from '@/store/scientific-topics/index'
import Create from './Create.vue'
import LTable from '@/views/components/LTable.vue'

export default {
  directives: {
    Ripple,
    'b-toggle': VBToggle,
  },
  components: {
    LTable,
    BButton,
    Create,
  },
  created() {
    this.$store.commit(`${this.MODULE_NAME}/FRESH`)
  },
  methods: {
    remove(data) {
      this.$removeSwal(this, data, `${this.MODULE_NAME}/del`, this.refetchData)
    },
    update(data) {
      const {
        id, name, region_id,
      } = data
      this.$store.commit(`${this.MODULE_NAME}/UPDATE`, {
        id,
        name,
        region: region_id,
      })
    },
    refetchData() {
      this.$refs.LTable.refetchData()
    },
    create() {
      this.$store.commit(`${this.MODULE_NAME}/FRESH`)
    },
  },
  setup() {
    const MODULE_NAME = 'scientificTopics'

    // Register module
    if (!store.hasModule(MODULE_NAME)) store.registerModule(MODULE_NAME, scientificTopics)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(MODULE_NAME)) store.unregisterModule(MODULE_NAME)
    })

    return {
      MODULE_NAME,
      ...config(),
    }
  },
}
</script>

<style lang="scss">
</style>
